var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.73656 13.6183C7.90513 13.2818 8 12.902 8 12.5C8 12.098 7.90513 11.7182 7.73656 11.3817M7.73656 13.6183C7.32611 14.4376 6.47874 15 5.5 15C4.11929 15 3 13.8807 3 12.5C3 11.1193 4.11929 10 5.5 10C6.47874 10 7.32611 10.5624 7.73656 11.3817M7.73656 13.6183L15.2634 17.3817M7.73656 11.3817L15.2634 7.61828M15.2634 17.3817C15.0949 17.7182 15 18.098 15 18.5C15 19.8807 16.1193 21 17.5 21C18.8807 21 20 19.8807 20 18.5C20 17.1193 18.8807 16 17.5 16C16.5213 16 15.6739 16.5624 15.2634 17.3817ZM15.2634 7.61828C15.6739 8.43757 16.5213 9 17.5 9C18.8807 9 20 7.88071 20 6.5C20 5.11929 18.8807 4 17.5 4C16.1193 4 15 5.11929 15 6.5C15 6.90197 15.0949 7.28179 15.2634 7.61828Z",
    stroke: "#424242",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e066fd2b3d5fd0e9fc0605334bdb4a6c.svg";
export { ForwardRef as ReactComponent };